import WithdrawnItemsView from './WithdrawnItemsView';

/** Povučeni rezervni delovi za posao — ista logika kao povučena roba iz magacina. */
const SparePartOutputsView = () => <WithdrawnItemsView fixedSourceType="SPARE_PART" />;

export default SparePartOutputsView;
